export let dateCol = {
	filter: 'agDateColumnFilter',
	suppressMenu: true,
	filterParams: {
		// provide comparator function
		comparator: function (filterLocalDateAtMidnight, cellValue) {
			let filterDate = moment(filterLocalDateAtMidnight).format('YYYY-MM-DD');
			let cellDate = moment(cellValue).format('YYYY-MM-DD');

			if (filterDate === cellDate || filterDate === '1970-1-1') {
				return 0;
			}

			if (cellDate < filterDate) {
				return -1;
			}

			if (cellDate > filterDate) {
				return 1;
			}
		}
	},
	minWidth: 120,
	editable: true,
	cellEditor: 'datePicker',
	cellRenderer: function (params) {
		let d;
		if (params.value != null && params.value.match(/[0-9]+\.[0-9]+\.[0-9]+/)) {
			let dateParts = params.value.split(".");
			d = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
		} else if (params.value == null || params.value == '') {
			return '';
		} else {
			let dateParts = params.value.split('T');
			d = new Date(dateParts[0]);
		}

		return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
	},
}
